export const ALL_CLOTHING__SHARED = 'allClothing'
export const ALL_PEOPLE__SHARED = 'allPeople'
export const SHANE__SHARED = 'shane'
export const USHER__SHARED = 'usher'

export const ALL_ACTOR_SHARED_STYLES = [
    ALL_CLOTHING__SHARED,
    ALL_PEOPLE__SHARED,
]
